<template>
  <div>
    <div class="docvue-background">
      <img src="/img/landing-page.jpg" />
      <div class="text-h4 text-center mt-4 pt-4">Please check your email for further instructions</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegisterSuccess",
  props: ["companyName"],
  data() {
    return {};
  },
};
</script>
